import { render, staticRenderFns } from "./AppAiAssessmentRoot.vue?vue&type=template&id=79e759eb&scoped=true"
import script from "./AppAiAssessmentRoot.vue?vue&type=script&lang=ts"
export * from "./AppAiAssessmentRoot.vue?vue&type=script&lang=ts"
import style0 from "./AppAiAssessmentRoot.vue?vue&type=style&index=0&id=79e759eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e759eb",
  null
  
)

export default component.exports